import cookie from 'js-cookie';
import format from './format';
import i18nMap from '../../i18n/i18n';

export const locale = window.__global_lang__ || cookie.get('_zm_lang') || 'en-US';

const REG_MULTI = /[\w\u007f-\uFFEF\{\}]+(\s*\|\s*[\w\u007f-\uFFEF\{\}]+)+/;

export const t = function(path, number, options) {
  if (!options && number) {
    options = number;
  }
  let value;
  const array = path.split('.');
  let current = i18nMap[locale] || i18nMap['en-US'];
  for (let i = 0, j = array.length; i < j; i++) {
    const property = array[i];
    value = current[property];

    if (i === j - 1) {
      if (REG_MULTI.test(value) && typeof number === 'number') {
        value = value.split('|')[number].trim();
      }
      return format(value, options);
    }
    if (!value) return '';
    current = value;
  }
  return '';
};
